<template>
<div class="page-container">
    <div class="hospital-item" v-for="(item,index) in data" :key="index">
        <div class="info-left">
            <span v-text="item.visitingDate"></span>
            <span v-text="getStatusName(item.visitingType)" class="hospital-status"></span>
        </div>
        <div class="info-right">
            <span v-text="item.hospitalName"></span>
            <span v-text="item.departmentName"></span>
            <span v-text="`${item.primaryPhysicianName || ''}`" v-show="item.primaryPhysicianName"></span>
            <span v-text="`诊断：${item.diagnosisName || ''}`"></span>
        </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
export default {
    name:'PatientInHospitalList',
    data() {
        return {

        }
    },
    props:{
        data:{
            type:[Array,Object],
            default(){
                return [];
            }
        },
    },
    components: {

    },
    methods:{
        getStatusName(code){
            if(code === 0){
                return '门诊'
            }else if(code === 1){
                return '住院'
            }else if(code === 2){
                return '体检'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page-container{
    .hospital-item{
        width:480px;
        min-height:160px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 8px 0px rgba(0,0,0,0.16),0px 0px 2px 0px rgba(0,0,0,0.3);
        border-radius:10px;
        display: flex;
        padding:15px 0 15px 20px;
        box-sizing: border-box;
        margin-top:20px;
        margin-bottom:20px;
        &:nth-of-type(1){
            margin-top:0px;
            margin-bottom:0px;
        }
        .info-left{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            flex-basis: 180px;
            min-width:180px;
            box-sizing: border-box;
            padding-top:15px;
            padding-bottom:22px;
            font-size:22px;
            font-weight:400;
            color:rgba(0,0,0,1);
            .hospital-status{
                color:#EB5463;
                font-size:24px;
                font-family:PingFangSC-Regular;
                font-weight:400;
            }
        }
        .info-right{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            border-left:1px solid rgba(216,216,216,1);
            padding-left:20px;
            font-size:20px;
            color:rgba(51,51,51,1);
            font-weight:400;
            &>span:nth-last-of-type(1){
                align-self: flex-start;
                text-align: left;
                line-height: 1.2em;
            }
            &>span{
                margin-top:12px;
                margin-bottom:12px;
            }
        }
    }
}
</style>
